import React, { useEffect, useState } from "react"

interface Props {
  type: string
  name: string
  placeholder: string
}
const useField = (inputProps: Props) => {
  const [value, setValue] = useState<string>('')
  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value)
  }
  return {
    value,
    onChange,
    ...inputProps
  }
}

export default useField
